import React from "react";
import ReactDOM from "react-dom/client";
import { Buffer } from 'buffer';
import "@/index.css";
import App from "@/App";

// react-pdf (and a few other Node-origin libs) expect a global Buffer. CRA
// doesn't polyfill it for the browser, so we attach it explicitly here.
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA / offline-friendly caching.
//
// On every deploy we bump the CACHE name inside service-worker.js. When the
// browser fetches the new service-worker.js it sees a different byte stream
// and downloads it into the "waiting" state. We then post SKIP_WAITING so the
// new worker takes over immediately, and reload the page once the active
// worker changes so the user is guaranteed to see the latest bundle.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { updateViaCache: 'none' })
      .then((registration) => {
        const promoteWaiting = () => {
          if (registration.waiting) {
            registration.waiting.postMessage('SKIP_WAITING');
          }
        };
        promoteWaiting();
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed') promoteWaiting();
          });
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('Service worker registration failed:', err);
      });

    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
